import { QueryList } from '@angular/core';
import { ArrowType, ArrowTypePanel } from 'markerjs2';
import { RadioComponent } from '../../../../../Common/Forms/components/Radio/radio.component';


export class ChartAnnotationArrowTypePanel extends ArrowTypePanel {

    radioGroup: HTMLDivElement;
    currentArrowType: ArrowType;
    radioComponents: QueryList<RadioComponent>;

    constructor(
        title: string,
        currentType?: ArrowType,
        icon?: string,
        radioGroup?: HTMLDivElement,
        radioComponents?: QueryList<RadioComponent>
    ) {
        super(
            title,
            currentType,
            icon
        );
        this.radioGroup = radioGroup;
        this.currentArrowType = currentType;
        this.radioComponents = radioComponents;
    }

    getUi(): HTMLDivElement {
        this.radioComponents.forEach(x => x.writeValue(this.currentArrowType));
        this.radioGroup.style.display = 'flex';
        return this.radioGroup;
    }
}
